import React, { Component } from 'react';
import cx from 'classnames';
import { FormattedDate } from 'react-intl';

import TranslatedCopy from '../../../scripts/intl/translated-copy';

const DEPARTURE = 0;
const RETURNING = 1;

class BookerCalendarPicker extends Component {
  render() {
    return (
      <div className='BookerCalendarPicker'>
        { this.renderPlaceHolderButton() }
      </div>
    );
  }

  renderPlaceHolderButton() {
    const {
      className,
      error,
      isBooking,
      isDatePickerActive,
      isHeaderQuickBooker,
      itinerary,
      noButton,
      onClick,
      singleDate,
      timatic,
      touched,
    } = this.props;

    const areDatesSelected = !singleDate ?
      (itinerary[DEPARTURE] !== null && itinerary[RETURNING] !== null) : itinerary[DEPARTURE] !== null;

    const noDatesSelected =  isDatePickerActive && itinerary[DEPARTURE] === null && itinerary[RETURNING] === null;
    const arrivalDateSelectedCopy =  !singleDate && itinerary[DEPARTURE] !== null && itinerary[RETURNING] === null;

    const buttonClasses = cx({
      'BookerCalendarPicker-isSelected': isDatePickerActive,
      'BookerCalendarPicker-placeholderButton': true,
      'BookerCalendarPicker-placeholderButtonColor': isBooking ? true : false,
      'carHertz': className ? true : false,
      'error': error && !touched && timatic,
      'Icon--calendar': true,
      'Icon': true,
      'is-notSelected': !areDatesSelected,
      'timatic': timatic,
      'touched': touched,
    });

    return (
      <div>
        { noButton ?
          <div className={ buttonClasses } onClick={ onClick }>
            <div>
              { areDatesSelected ? this.renderPlaceholder() :
                noDatesSelected ? <TranslatedCopy copyID='MINICALENDAR_DEPARTURE' /> :
                  arrivalDateSelectedCopy ? <TranslatedCopy copyID='MINICALENDAR_ARRIVAL' /> : <TranslatedCopy copyID='APP_WHEN' />
              }
            </div>
          </div>
          : !isHeaderQuickBooker ?
            <button
              className={ buttonClasses }
              onClick={ onClick }>
              { areDatesSelected ? this.renderPlaceholder() :
                noDatesSelected ? <TranslatedCopy copyID='MINICALENDAR_DEPARTURE' /> :
                  arrivalDateSelectedCopy ? <TranslatedCopy copyID='MINICALENDAR_ARRIVAL' /> : <TranslatedCopy copyID='APP_WHEN' />
              }
            </button>
            :
            <button
              className={ buttonClasses }
              onClick={ onClick }>
              { areDatesSelected ? this.renderPlaceholder() :
                noDatesSelected ? <TranslatedCopy copyID='MINICALENDAR_DEPARTURE' /> :
                  arrivalDateSelectedCopy ? <TranslatedCopy copyID='MINICALENDAR_ARRIVAL' /> :
                    singleDate ? <TranslatedCopy copyID='MENU_RESERVA_DATES_OW' /> : this.renderGoReturn()
              }
            </button>
        }
      </div>
    );
  }

  renderGoReturn() {
    return (
      <span>
        <TranslatedCopy copyID='CC_GO' />  —  <TranslatedCopy copyID='CC_RETURN' />
      </span>
    );
  }

  renderPlaceholder() {
    const { itinerary, singleDate } = this.props;

    return (
      <div>
        <FormattedDate
          day='numeric'
          month='short'
          value={ itinerary[DEPARTURE] }/>
        { !singleDate ?
          <span>
            &nbsp;&mdash;&nbsp;
            <FormattedDate
              day='numeric'
              month='short'
              value={ itinerary[RETURNING] } />
          </span>
          : null }
      </div>
    );
  }
}

export default BookerCalendarPicker;
